import React from 'react';
import AssetRegisterTreeView from '../../../../model/AssetRegisterTreeView';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import useTranslation from '../../utils/Translations/useTranslation';
import SelectBoxFilter from './SelectBoxFilter';
const AssetRegisterTreeViewSelector = ({ value, onChange, name }) => {
    const { t } = useTranslation();
    const { options } = useEnumerableModel(AssetRegisterTreeView);
    return (<SelectBoxFilter name={name} options={options} title={t('View')} value={value} onChange={onChange}/>);
};
export default AssetRegisterTreeViewSelector;
